"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterTimestamps = void 0;
const moment_1 = __importDefault(require("moment"));
const dateFormat_1 = require("../types/dateFormat");
const timelapse_1 = require("../types/timelapse");
const filterTimestamps = (timestamps, timeRange) => {
    const now = moment_1.default.utc();
    let startTime;
    switch (timeRange) {
        case timelapse_1.TimeRanges.HOURS_24:
            startTime = now.clone().subtract(24, "hours");
            break;
        case timelapse_1.TimeRanges.DAYS_3:
            startTime = now.clone().subtract(3, "days");
            break;
        case timelapse_1.TimeRanges.DAYS_7:
            startTime = now.clone().subtract(7, "days");
            break;
        default:
            startTime = now.clone().subtract(24, "hours");
            break;
    }
    const filtered = Object.keys(timestamps)
        .filter((timestamp) => {
        const parsedTimestamp = moment_1.default.utc(timestamp, dateFormat_1.DateFormat.us_with_time_seconds_utc);
        return parsedTimestamp.isAfter(startTime);
    })
        .sort((a, b) => moment_1.default
        .utc(a, dateFormat_1.DateFormat.us_with_time_seconds_utc)
        .diff(moment_1.default.utc(b, dateFormat_1.DateFormat.us_with_time_seconds_utc)));
    if (filtered.length === 0) {
        return Object.keys(timestamps).sort((a, b) => moment_1.default
            .utc(a, dateFormat_1.DateFormat.us_with_time_seconds_utc)
            .diff(moment_1.default.utc(b, dateFormat_1.DateFormat.us_with_time_seconds_utc)));
    }
    return filtered;
};
exports.filterTimestamps = filterTimestamps;
